import { Box, Grid, Stack, Tab, Tabs } from "@mui/material";
import orderBy from "lodash/orderBy";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import type { AdminProductOptionResponse } from "../productsApi";
import { useProductOptions } from "../useProductOptions";
import NewOption from "./NewOption";
import ProductOptionEdit from "./ProductOptionEdit";

function a11yProps(id: string) {
  return {
    id: `vertical-tab-${id}`,
    "aria-controls": `vertical-tabpanel-${id}`,
  };
}

const SingleOptionEdit = () => {
  const { productId, provider, options } = useOutletContext<{
    readonly productId: string;
    readonly provider: {
      readonly id: string;
      readonly useDynamicPrices: boolean;
      readonly computePricesFromPurchasePrice: boolean;
    };
    readonly options: AdminProductOptionResponse[];
  }>();
  const { createOption } = useProductOptions(productId);
  const [selectedOption, setSelectedOption] = useState<string>();

  useEffect(() => {
    if (options.length > 0) {
      setSelectedOption(options[0].id);
    }
  }, [options]);

  const handleAddNewOption = async (newOptionName: string) => {
    if (newOptionName.length > 0) {
      await createOption(newOptionName);
    }
  };

  const sortedOptions = orderBy(options, (o) => o.name.toLowerCase());
  const optionToEdit = options?.find((o) => o.id === selectedOption);
  const optionsAvailable = options?.length > 0 && optionToEdit;
  return (
    <Stack direction="column" spacing={1} data-testid="single-option-edit">
      {optionsAvailable && (
        <Stack direction="row">
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={selectedOption}
            onChange={(_, newValue) => setSelectedOption(newValue)}
            aria-label="Zasoby produktu"
            sx={{ borderRight: 1, borderColor: "divider", flexShrink: 0 }}
          >
            {sortedOptions.map((o) => (
              <Tab key={o.id} label={o.name} value={o.id} {...a11yProps(o.id)} />
            ))}
          </Tabs>
          <Box
            role="tabpanel"
            id={`vertical-tabpanel-${selectedOption}`}
            aria-labelledby={`vertical-tab-${selectedOption}`}
            sx={{
              padding: 2,
              flexGrow: 1,
            }}
          >
            <ProductOptionEdit productId={productId} provider={provider} option={optionToEdit} />
          </Box>
        </Stack>
      )}
      <Grid container>
        <Grid size={{ xs: 4, lg: 3 }}>
          <NewOption onAdd={handleAddNewOption} />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default SingleOptionEdit;
